import React, { useContext, useEffect, useState } from "react";
import Function from "../../../StateContext/Application";
import { Form } from "react-router-dom";
import CreateEmployee from "../Create Employee/CreateEmployee";
import { EditBlueBlue32, Email32, PhoneNumber32,  Cancel32,
  submit } from "../../../../../public/LoginImages/importimages";

const EditViewEmp = () => {
  const types = useContext(Function);
  const { EmployeeManagement, Roles, DepartmentHandler } = types;
  const [Employees, SetEmployees] = useState([]);
  const [Search, SetSearch] = useState(null);
  const [searchdata, SetSearchData] = useState([]);
    const [showPassword, setShowPassword] = useState(false);//03-11
  
  const [Role, SetRole] = useState([]);
  // 29-09
    const [isEditing, setIsEditing] = useState(false);
  const [DepartmentList, SetDepartment] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
   
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
   
  const currentEmployees = Employees.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
   
  const totalPages = Math.ceil(Employees.length / itemsPerPage);
  var [form, setForm] = useState({
    type: "Edit",
    FullName: "",
    PhoneNumber: "",
    Email: "",
    Password: "",
    RoleID: "",
    Role: "",
    Department_ID: "",
    Department_Name: "",
  });
  useEffect(() => {
    GetData();
  }, []);
  const handleChange = (e) => {
    try {
      if (e.target.id === "Department_Name") {
        let obj = JSON.parse(e.target.value);
        form.Department_Name = obj.Department_Name;
        form.Department_ID = obj.Department_ID;
      } else if (e.target.id === "Role") {
        let obj = JSON.parse(e.target.value);
        form.Role = obj.Designation;
        form.RoleID = obj.RoleID;
      } else {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
      }
    } catch (error) {
      console.error('Error handling change:', error);
    }
  };
  async function GetData() {
    try {
      let data = await EmployeeManagement("View", Search);
      let data1 = await Roles("View", null);
      let department = await DepartmentHandler("view", null, null);
      SetDepartment(department);
      SetRole(data1);
      SetEmployees(data);
      SetSearchData(data);
       // 29-09----sorting data
      const sortedData = [...data].reverse();
 
SetEmployees(sortedData);
SetSearchData(sortedData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  function Display_Option(id) {
    try {
      let data = document.getElementById(id);

      if (data.style.display === "none") {
        data.style.display = "block";
      } else {
        data.style.display = "none";
      }
    } catch (error) {
      console.error('Error displaying option:', error);
    }
  }

  function Editing_Options(emp) {
    try {
      setForm(emp);
    } catch (error) {
      console.error('Error setting form:', error);
    }
  }

  const SearchEmployee = (e) => {
    try {
      let searchValue = e.target.value.toLowerCase();

      if (!searchValue) {
        SetEmployees(searchdata);
        return;
      }

      let newData = searchdata.filter((item) => {
        return (
          item.FullName.toLowerCase().includes(searchValue) ||
          item.PhoneNumber.toLowerCase().includes(searchValue) ||
          item.Email.toLowerCase().includes(searchValue) ||
          item.Password.toLowerCase().includes(searchValue) ||
          item.RoleID.toString().toLowerCase().includes(searchValue) ||
          item.Role.toLowerCase().includes(searchValue) ||
          item.Department_ID.toString().toLowerCase().includes(searchValue) ||
          item.Department_Name.toLowerCase().includes(searchValue)
        );
      });
      console.log(newData);
      SetEmployees(newData);
    } catch (error) {
      console.error('Error searching employees:', error);
    }
  };

  async function SubmitEdit() {
    try {
      let b = await EmployeeManagement("Update", form);
    } catch (error) {
      console.error('Error submitting edit:', error);
    }
  }
// 12-10 naviagete the page after the update
 async function SubmitEdit(e) {
  e.preventDefault();
 
  try {
    let b = await EmployeeManagement("Update", form);
 
    setIsEditing(false);
 
    await GetData();
 
  } catch (error) {
    console.error("Error submitting edit:", error);
  }
}
 

const labelStyle = {
  display: "block",
  marginBottom: "8px",
  fontWeight: "600",
  fontSize: "13px",
};
return (
  <div
    // className="container"
   style={{
      padding: "10px 20px",
    backgroundColor: "white",
    marginTop: "20px",
    marginBottom: "0px",
    marginLeft: "0px",
    width: "100%",
    boxSizing: "border-box",
    height: "85vh",            // fixed height
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  }}
  >
    <style>{`
  .hide-scrollbar {
    scrollbar-width: none;        /* Firefox */
    -ms-overflow-style: none;     /* old Edge / IE */
  }
  .hide-scrollbar::-webkit-scrollbar {
    display: none;                /* Chrome, Edge, Safari */
  }
`}</style>
    <h5 style={{ fontSize: "20px", fontWeight: "700" }}>
      <img
        src="/Create-Employee-32.png"
        alt="img"
        style={{ height: "28px", width: "28px" }}
      />{" "}
      Edit/View User
    </h5>
<div className="hide-scrollbar"
  style={{
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    overflowX: "hidden",
    paddingRight: "4px",
  }}
>
    {/* ================= LIST VIEW ================= */}
    {!isEditing && (
      <div
        // className="col-12 m-auto my-5"
         style={{
    border: "1px solid #d5dce5",
    borderRadius: "12px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.12)",
    backgroundColor: "#eef2f8",
    padding: "20px 20px 25px",
    boxSizing: "border-box",
    width: "100%",
    marginTop: "15px",
  }}
      >
        {/* Header: title + search */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 20px 18px",
          }}
        >
          <button
            style={{
              border: "none",
              background: "transparent",
              fontSize: "20px",
              fontWeight: "700",
              color: "black",
              padding: 0,
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}
            onClick={() => Display_Option("create_Employee")}
          >
            <img
              src="/Create-Employee-32.png"
              alt=""
              style={{ width: "28px", height: "28px" }}
            />
            Users
          </button>

          <Form onSubmit={GetData} style={{ width: "300px" }}>
            <div style={{ position: "relative" }}>
              <span
                style={{
                  position: "absolute",
                  left: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  width: "22px",
                  height: "22px",
                  borderRadius: "4px",
                  backgroundColor: "#e3eefb",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "12px",
                  color: "#2D79D9",
                }}
              >
                🔍
              </span>
              <input
                type="search"
                className="form-control"
                placeholder="Search User by Name/Email/Role ID"
                onChange={SearchEmployee}
                style={{
                  width: "100%",
                  height: "36px",
                  paddingLeft: "42px",
                  borderRadius: "6px",
                  border: "1px solid #cfd6df",
                  fontSize: "14px",
                  boxShadow: "none",
                }}
              />
            </div>
          </Form>
        </div>

        {/* Create Employee (toggle by clicking "Users") */}
        <div
          id="create_Employee"
          style={{ display: "none", marginBottom: "15px" }}
        >
          <CreateEmployee />
        </div>

        {/* White inner card */}
        <div
          style={{
            width: "100%",
            backgroundColor: "#ffffff",
            borderRadius: "14px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
            padding: "20px",
            boxSizing: "border-box",
          }}
        >
          {/* Table (horizontal scroll) */}
          <div
            style={{
              overflowX: "auto",
              width: "100%",
              border: "1px solid #d9e1f2",
              borderRadius: "10px",
              boxSizing: "border-box",
            }}
          >
            <table
              style={{
                width: "100%",
                minWidth: "70vw",
                borderCollapse: "separate",
                borderSpacing: 0,
                backgroundColor: "white",
              }}
            >
              <thead>
                <tr
                  style={{
                    backgroundColor: "#2D79D9",
                    color: "white",
                    height: "3rem",
                    fontSize: "15px",
                  }}
                >
                  {[
                    "Sr.No",
                    "Full Name",
                    "Phone Number",
                    "Email",
                    "RoleID",
                    "Role",
                    "Department_ID",
                    "Department_Name",
                    "Action",
                  ].map((h, i, arr) => (
                    <th
                      key={h}
                      style={{
                        padding: "8px 12px",
                        textAlign: "center",
                        fontWeight: "700",
                        whiteSpace: "nowrap",
                        borderRight:
                          i === arr.length - 1 ? "none" : "1px solid white",
                        borderTopLeftRadius: i === 0 ? "10px" : 0,
                        borderTopRightRadius:
                          i === arr.length - 1 ? "10px" : 0,
                      }}
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {currentEmployees.map((emp, index) => {
                  const cell = {
                    textAlign: "center",
                    verticalAlign: "middle",
                    padding: "14px 12px",
                    fontSize: "14px",
                    color: "#222",
                    fontWeight: "400",
                    border: "1px solid white",
                  };
                  return (
                    <tr
                      key={index}
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? "#E5F4FB" : "#CEE4F1",
                      }}
                    >
                      <td style={cell}>{indexOfFirstItem + index + 1}</td>
                      <td style={cell}>{emp.FullName}</td>
                      <td style={cell}>
                        <img
                          src={PhoneNumber32}
                          alt=""
                          style={{
                            width: "17px",
                            marginRight: "6px",
                            verticalAlign: "middle",
                          }}
                        />
                        {emp.PhoneNumber}
                      </td>
                      <td style={{ ...cell, color: "blue" }}>
                        <img
                          src={Email32}
                          alt=""
                          style={{
                            width: "17px",
                            marginRight: "6px",
                            verticalAlign: "middle",
                          }}
                        />
                        {emp.Email}
                      </td>
                      <td style={cell}>{emp.RoleID}</td>
                      <td style={cell}>{emp.Role}</td>
                      <td style={cell}>{emp.Department_ID}</td>
                      <td style={cell}>{emp.Department_Name}</td>
                      <td style={cell}>
                        <button
                          className="btn btn-custom-edit"
                          style={{
                            width: "4rem",
                            margin: "0 auto",
                            border: "1px solid #502eff",
                            backgroundColor: "white",
                            borderRadius: "5px",
                            fontSize: "10px",
                            color: "#502eff",
                            padding: "5px",
                            fontWeight: "700",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "3px",
                            transition: "all 0.2s ease",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#502eff";
                            e.currentTarget.style.color = "white";
                            e.currentTarget.querySelector("img").style.filter =
                              "brightness(0) invert(1)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = "white";
                            e.currentTarget.style.color = "#502eff";
                            e.currentTarget.querySelector("img").style.filter =
                              "none";
                          }}
                          onClick={() => {
                            Editing_Options(emp);
                            setIsEditing(true);
                          }}
                        >
                          <img
                            src={EditBlueBlue32}
                            alt="Edit"
                            style={{
                              width: "1.3rem",
                              transition: "all 0.2s ease",
                            }}
                          />
                          Edit
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {currentEmployees.length === 0 && (
            <div
              style={{
                height: "60px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "15px",
                color: "#777",
                fontWeight: "600",
              }}
            >
              No Data Available
            </div>
          )}

          {/* Footer: entries + pagination */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "20px",
              padding: "0 5px",
            }}
          >
            <div style={{ fontSize: "14px", color: "#222" }}>
              Showing {Employees.length === 0 ? 0 : indexOfFirstItem + 1} to{" "}
              {Math.min(indexOfLastItem, Employees.length)} of{" "}
              {Employees.length} entries
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "18px",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              <span
                onClick={() =>
                  currentPage > 1 && setCurrentPage(currentPage - 1)
                }
                style={{
                  color: currentPage === 1 ? "#b5d7f5" : "#5aa9e6",
                  cursor: currentPage === 1 ? "default" : "pointer",
                }}
              >
                ‹ Previous
              </span>

              {Array.from({ length: totalPages }, (_, i) => (
                <span
                  key={i}
                  onClick={() => setCurrentPage(i + 1)}
                  style={{
                    color: currentPage === i + 1 ? "#198ed1" : "#5aa9e6",
                    textDecoration:
                      currentPage === i + 1 ? "underline" : "none",
                    cursor: "pointer",
                  }}
                >
                  {i + 1}
                </span>
              ))}

              <span
                onClick={() =>
                  currentPage < totalPages && setCurrentPage(currentPage + 1)
                }
                style={{
                  color:
                    currentPage === totalPages || totalPages === 0
                      ? "#b5d7f5"
                      : "#5aa9e6",
                  cursor:
                    currentPage === totalPages || totalPages === 0
                      ? "default"
                      : "pointer",
                }}
              >
                Next ›
              </span>
            </div>
          </div>
        </div>
      </div>
    )}


    {/* ================= EDIT FORM ================= */}
    {isEditing && (
      <div className="container my-4" id="edit_emp">
        <div
          className="card p-4"
          style={{
            borderRadius: "12px",
            border: "1px solid #d9e1f2",
            backgroundColor: "#edf5fc",
            boxShadow: "0 3px 10px rgba(0,0,0,0.08)",
          }}
        >
          <h4
            className="text-center mb-4"
            style={{ fontWeight: "700", color: "#222" }}
          >
            Edit User
          </h4>

          <Form onSubmit={SubmitEdit}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                columnGap: "25px",
                rowGap: "15px",
              }}
            >
              {/* Full Name */}
              <div>
                <label style={labelStyle}>Full Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="FullName"
                  value={form.FullName}
                  onChange={handleChange}
                  required
                  style={{ width: "100%", height: "40px" }}
                />
              </div>

              {/* Phone Number */}
              <div>
                <label style={labelStyle}>Phone Number</label>
                <input
                  type="tel"
                  className="form-control"
                  name="PhoneNumber"
                  value={form.PhoneNumber}
                  onChange={handleChange}
                  style={{ width: "100%", height: "40px" }}
                />
              </div>

              {/* Email */}
              <div>
                <label style={labelStyle}>Email</label>
                <input
                  type="email"
                  className="form-control"
                  name="Email"
                  value={form.Email}
                  onChange={handleChange}
                  placeholder="Enter Email Here"
                  style={{ width: "100%", height: "40px" }}
                />
              </div>

              {/* Password */}
              {/* <div>
                <label style={labelStyle}>Password</label>
                <input
                  type="password"
                  className="form-control"
                  name="Password"
                  value={form.Password}
                  onChange={handleChange}
                  placeholder="Enter Password Here"
                  style={{ width: "100%", height: "40px" }}
                />
              </div> */}
{/* 03-11 */}
 
 
 {/* Password */}
<div>
  <label style={labelStyle}>Password</label>
  <div style={{ position: "relative" }}>
    <input
      type={showPassword ? "text" : "password"}
      className="form-control"
      name="Password"
      value={form.Password}
      onChange={handleChange}
      placeholder="Enter Password Here"
      style={{ width: "100%", height: "40px", paddingRight: "44px" }}
    />
    <button
      type="button"
      onClick={() => setShowPassword(!showPassword)}
      aria-label={showPassword ? "Hide password" : "Show password"}
      style={{
        position: "absolute",
        right: "10px",
        top: "50%",
        transform: "translateY(-50%)",
        border: "none",
        background: "transparent",
        padding: 0,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        color: "#555",
      }}
    >
      {showPassword ? (
        /* Eye-off icon (password visible, click to hide) */
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
          <line x1="1" y1="1" x2="23" y2="23" />
        </svg>
      ) : (
        /* Eye icon (password hidden, click to show) */
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
      )}
    </button>
  </div>
</div>
              {/* Department */}
              <div>
                <label style={labelStyle}>Select Department</label>
                <select
                  className="form-control"
                  id="Department_Name"
                  onChange={(e) => handleChange(e)}
                >
                  <option value={form.Department_ID}>
                    {form.Department_Name}
                  </option>
                  {DepartmentList.map((e) => (
                    <option key={e.Department_ID} value={JSON.stringify(e)}>
                      {e.Department_Name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Role */}
              <div>
                <label style={labelStyle}>Role</label>
                <select
                  className="form-control"
                  id="Role"
                  onChange={(e) => handleChange(e)}
                >
                  <option value={form.RoleID}>{form.Role}</option>
                  {Role.map((e) => (
                    <option key={e.RoleID} value={JSON.stringify(e)}>
                      {e.Designation}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Buttons */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "20px",
                marginTop: "30px",
              }}
            >
              <button
                type="submit"
                style={{
                  minWidth: "105px",
                  height: "40px",
                  border: "none",
                  borderRadius: "7px",
                  background: "linear-gradient(90deg, #3b35b5, #009bd5)",
                  color: "#fff",
                  fontWeight: "600",
                  fontSize: "14px",
                  cursor: "pointer",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                }}
              >
                <img
                  src={submit}
                  alt=""
                  style={{
                    width: "32px",
                    height: "18px",
                    objectFit: "contain",
                    paddingRight: "10px",
                  }}
                />
                Submit
              </button>

              <button
                type="button"
                onClick={() => {
                  setIsEditing(false);
                  setForm({
                    type: "Edit",
                    FullName: "",
                    PhoneNumber: "",
                    Email: "",
                    Password: "",
                    RoleID: "",
                    Role: "",
                    Department_ID: "",
                    Department_Name: "",
                  });
                }}
                style={{
                  minWidth: "105px",
                  height: "40px",
                  border: "none",
                  borderRadius: "7px",
                  backgroundColor: "#f76565",
                  color: "#fff",
                  fontWeight: "600",
                  fontSize: "14px",
                  cursor: "pointer",
                  boxShadow: "0 3px 7px rgba(0,0,0,0.10)",
                }}
              >
                <img
                  src={Cancel32}
                  alt=""
                  style={{ marginRight: "10px", width: "1.2rem" }}
                />
                Cancel
              </button>
            </div>
          </Form>
        </div>
      </div>
    )}
  </div>
      </div>
);
 
};
export default EditViewEmp;
